import SngpcManualModel from "@/models/sngpcManualModel";
import nfetch from "@/utils/events/nfetch";

import { IService } from "../base/iService";

import PDFService from "./PDFService";

export default class BspoPDFService extends IService<SngpcManualModel> {
    public pdfService = new PDFService("BspoPDF");

    constructor() {
        super("BspoPDF");
    }

    public getDados(): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetDados`, {
            credentials: "same-origin",
        });
    }
}
